import React from "react";
import { Row, Col, Card, Spinner, Alert, Button } from "react-bootstrap";
import ImprovedSalesChart from "./ImprovedSalesChart";
import ModernSalesTargetSummaryChart from "./ModernSalesTargetSummaryChart";
import { SalesData } from "../types";

interface DashboardChartsProps {
  salesData: SalesData[];
  summaryData: {
    totalTarget: number;
    totalAchieved: number;
    overAchievers: number;
    underPerformers: number;
  };
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
}

export const DashboardCharts: React.FC<DashboardChartsProps> = ({
  salesData,
  summaryData,
  loading,
  error,
  onRefresh,
}) => {
  return (
    <Row className="mb-4">
      <Col lg={8} className="mb-3">
        <div className="slide-in-left">
          {loading ? (
            <Card
              className="border-0 shadow-sm"
              style={{ height: "620px" }}
            >
              <Card.Body className="d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">
                    Carregando dados...
                  </p>
                </div>
              </Card.Body>
            </Card>
          ) : error ? (
            <Card
              className="border-0 shadow-sm"
              style={{ height: "620px" }}
            >
              <Card.Body className="d-flex align-items-center justify-content-center">
                <Alert variant="danger" className="text-center">
                  <div>{error}</div>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={onRefresh}
                    className="mt-2"
                  >
                    Tentar novamente
                  </Button>
                </Alert>
              </Card.Body>
            </Card>
          ) : (
            <ImprovedSalesChart data={salesData} height={620} />
          )}
        </div>
      </Col>
      <Col lg={4} className="mb-3">
        <div className="slide-in-right">
          <ModernSalesTargetSummaryChart
            data={summaryData}
            height={460}
          />
        </div>
      </Col>
    </Row>
  );
};
